import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../BigPic/BigPic.scss';
import './BigVideoWrapper.scss';
import { IComponentLiveShow } from '../../component';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import LiveShow from './LiveShow';
import { IMedium } from '../../store/VideoStore';
import RootStore from '../../store/RootStore';
import SwipeableViews from 'react-swipeable-views';
import intl from 'react-intl-universal';
import { isWeb } from '../../utils/util';
import imageUtil from '../../utils/image';
import Player from '../VideoV2/Player';
import VideoManager from '../VideoV2/Manager';
import { BigPicHeader } from '../BigPic/BigPicMain';
import SearchRow from '../ComponentVote/Search';
import ReactSVG from 'react-svg';
import ListWrapper, { ILoadMoreResult } from '../Common/ListWrapper';

import {
  isInMiniProgram,
  getToMiniProgramDownloadUrl
} from '../../utils/mini_program';
import useVideoCore from './useVideoCore';

interface IBigVideoWrapper extends IComponentLiveShow {
  rootStore?: RootStore;
}

const ToMiniProgramBtn = (props: { downloadUrl: string }) => {
  let { downloadUrl } = props;
  if (isInMiniProgram()) {
    const { miniProgram } = window.wx || {};
    return (
      <div
        style={{
          color: '#fff',
          textAlign: 'center',
          fontSize: 12,
          flex: 1
        }}
        onClick={() =>
          miniProgram && miniProgram.navigateTo({ url: '/' + downloadUrl })
        }
      >
        {intl.get('Download')}
      </div>
    );
  }
  return (
    <wx-open-launch-weapp
      id="launch-btn"
      username="gh_e97c78460d68"
      path={downloadUrl}
      style={{ flex: 1 }}
    >
      <script type="text/wxtag-template">
        {/*注意，需要最小宽度，否则容易出现字换行的情况， white-space:nowrap也无法解决*/}
        <div
          style={{
            color: '#fff',
            textAlign: 'center',
            fontSize: 12
          }}
        >
          {intl.get('Download')}
        </div>
      </script>
    </wx-open-launch-weapp>
  );
};

export const SimpleBigVideo = (props: {
  list: IMedium[];
  index: number;
  setIndex: (index: number) => void;
  onClose: () => void;
  onStatusChange: (status: string, index: number) => void;
  rootStore?: RootStore;
  mode: string;
  download?: boolean;
  search?: string;
}) => {
  const {
    index,
    list,
    setIndex,
    onClose,
    onStatusChange,
    rootStore,
    mode,
    search
  } = props;
  const { wxuserStore, videoStore } = rootStore!;

  const onSwitching = (ind: number, type: string) => {
    if (type === 'end') {
      // 移动结束
      if (ind === props.list.length - 1) {
        // 已经到底了，最后一张右滑后弹回来了
        // props.rootStore!.uiStore.showToast({
        //   content: intl.get('This is the last one video')
        // });
      }
    }
  };

  const { onCreated, bigVideoWrapper, size } = useVideoCore({
    list,
    index,
    mode
  });

  const onIndexChange = (ind: number) => {
    let keys = VideoManager.keys();
    keys.forEach((key: string) => {
      let instance = VideoManager.getPlayerInstance(key);
      if (instance) {
        instance.pause();
      }
    });

    setIndex(ind);
  };

  const nextClick = () => {
    if (index >= list.length - 1) {
      props.rootStore!.uiStore.showToast({
        content: intl.get('This is the last one video')
      });
      return;
    } else {
      // setIndex(index + 1);
      onIndexChange(index + 1);
    }
  };

  const getHeaderText = () => {
    // if (!!search) {
    //   let item = list[index];
    //   if (item.status == 'start') {
    //     return `点击【隐藏视频】，此视频仅能搜索后查看，进入直播间不显示`;
    //   }
    //   if (item.status == 'end') {
    //     return `点击【我要上热门】，此视频被推荐为热门视频进入直播间可查看`;
    //   }
    // }

    // return '提示：当前视频为热门推荐，若需隐藏，请再次输入编号在搜索结果中操作';
    return ' ';
  };

  const shouldShowDownloadBtn = () => {
    if (props.download) {
      return (
        (!window.isweixin &&
          !window.isweixinweb &&
          window.screen.availWidth > 800) ||
        (window.isweixin && !window.isweixinweb)
      );
    }

    return false;
  };

  const shouldShowOperationBtn = () => {
    if (!!search) {
      return true;
    }
    return false;
  };

  const getOperationText = () => {
    let item = list[index];
    if (item.status == 'start') {
      return '隐藏视频';
    }
    if (item.status == 'end') {
      return '我要上热门';
    }
  };

  const getDownloadUrl = () => {
    let item = list[index];

    let url = getToMiniProgramDownloadUrl(
      [
        {
          id: item.id,
          url: `https://image6${window.__basename}/${item.source}`
        }
      ],
      'video'
    );
    return url;
  };

  return createPortal(
    <div className={'big-video-fixed ' + `type-${mode}`}>
      <div className="slider-wrapper big-pic-main">
        <SwipeableViews
          axis="x"
          enableMouseEvents={true}
          index={index}
          onChangeIndex={onIndexChange}
          onSwitching={onSwitching}
          // 如果不设置成hidden，在大图页会出现右侧的滑动条（0.x秒后消失)
          slideStyle={{ overflow: 'hidden' }}
          resistance={true}
          containerStyle={{
            height: 'var(--vh)',
            width: '100%',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {list.map((one, dataIndex) => {
            if (Math.abs(dataIndex - index) < 3) {
              return (
                <div className="video-calc" style={size} key={one.id}>
                  <Player
                    key={one.id}
                    source={one}
                    width={`100%`}
                    height={mode == 'h' ? `calc(100% - 44px)` : '100%'}
                    autoPlay={false}
                    danmuku={false}
                    rootStore={rootStore}
                    targetId={`bigvideo_${one.id}`}
                    onCreated={onCreated}
                  />
                </div>
              );
            } else {
              return <div key={'empty' + dataIndex} />;
            }
          })}
        </SwipeableViews>
      </div>
      <div className="bigpic-wrapper" onClick={e => e.stopPropagation()}>
        <BigPicHeader
          hideOrigin
          detail={list[index]}
          currentImageIndex={index}
          count={list.length}
          tips={getHeaderText()}
        />
        <div className="bigpic-operation">
          <img
            src={require('../../assets/x-circle.png')}
            alt=""
            className="bigpic-close position-big-video-wrapper2"
            onClick={() => {
              onIndexChange(-1);
              onClose();
            }}
          />
        </div>
        {/*}<img
        src={require('../../assets/x-circle.png')}
        alt=""
        className="bigpic-close"
        onClick={() => setIndex(-1)}
      />*/}
        {/*随意写一个高度试试，IOS上显示有问题，不明为什么*/}
        <div style={{ flex: 1, zIndex: -1, height: 100 }} />
        <div className="bigpic-bottom">
          {/* 从我的喜欢进来的目前没有返回size，所以这里做判断隐藏*/}
          <div style={{ flex: 1 }} />
          <div className="bigpic-bottom-info-wrapper">
            {shouldShowOperationBtn() ? (
              <span
                className="big-pic-info"
                onClick={() => {
                  if (wxuserStore.user.is_mock) {
                    wxuserStore.auth();
                    return;
                  }

                  let realList = !!search
                    ? videoStore.liveshow_search.items
                    : videoStore.liveshow_list.items;
                  let item = realList[index];
                  if (item) {
                    if (item.status == 'start') {
                      onStatusChange('end', index);
                    }
                    if (item.status == 'end') {
                      onStatusChange('start', index);
                    }
                  }
                }}
              >
                {getOperationText()}
              </span>
            ) : null}
            {shouldShowDownloadBtn() && 0 ? (
              <span className="big-pic-info">
                {wxuserStore.user.is_mock ? (
                  // 没有登录的，一律要求登录
                  <span
                    onClick={() => {
                      wxuserStore.auth();
                    }}
                  >
                    下载
                  </span>
                ) : window.isweixin && !window.isweixinweb ? (
                  <ToMiniProgramBtn downloadUrl={getDownloadUrl()} />
                ) : (
                  <span
                    className="pcdownload"
                    onClick={() => {
                      let item = list[index];
                      imageUtil.downloadImage(
                        `//image6${window.__basename}/${item.source}`,
                        item.desc + (item.desc.match(/\.mp4$/) ? '' : '.mp4')
                      );
                    }}
                  >
                    下载
                  </span>
                )}
              </span>
            ) : null}
            <div
              className="icon"
              style={{ marginRight: 15 }}
              onClick={nextClick}
            >
              <ReactSVG
                src={require('../../svg/right-arrow.svg')}
                className={'icon-normal icon-right-arrow2'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>,
    bigVideoWrapper
  );
};

let currentPage = 1;

const Index = (props: IBigVideoWrapper) => {
  const { videoStore, wxuserStore, uiStore } = props.rootStore!;

  const list = videoStore.liveshow_list.items;
  const [currentIndex, setCurrentIndex] = useState(-1);

  const onPlay = (item: IMedium, index: number) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    videoStore.getLiveShowList(window.gallery.id, currentPage);
  }, []);

  const onRefresh = () => {
    return new Promise(resolve => {
      currentPage = 1;
      resolve(videoStore.liveshow_list.items);
    });
  };

  const onLoadMore = () => {
    return new Promise<ILoadMoreResult>(resolve => {
      currentPage += 1;
      videoStore.getLiveShowList(window.gallery.id, currentPage).then(res => {
        resolve({
          nomore: 40 * (currentPage + 1) > videoStore.liveshow_list.total,
          message: ''
        });
      });
    });
  };

  const [search, setSearch] = useState('');

  const onSearch = (val: string) => {
    if (val == search) {
      return;
    }

    setSearch(val);

    if (val) {
      videoStore.getLiveSearch(window.gallery.id, val).then((res: any) => {
        if (res && res.total && res.items) {
          setCurrentIndex(0);
        }
      });
    } else {
      videoStore.getLiveShowList(window.gallery.id);
    }
  };

  const { h1Color, h2Color, mainColor } = useTheme();

  const onStatusChange = (sts: string, ind: number) => {
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return;
    }
    let realList = !!search
      ? videoStore.liveshow_search.items
      : videoStore.liveshow_list.items;
    let one = realList[ind];
    videoStore
      .upLiveShowStatus(window.gallery.id, one.id, sts)
      .then((res: any) => {
        if (res && res.code == 200) {
          uiStore.showToast({
            content: intl.get('Success'),
            time: 2000,
            icon: 'success-no-circle'
          });
        }
      });
  };

  const searchRef = useRef<any>();

  return (
    <div className="bigvideo-wrapper">
      {!!props.search ? (
        <div className="vote">
          <SearchRow
            search={onSearch}
            placeholder="请输入名称"
            h1Color={h1Color}
            h2Color={h2Color}
            mainColor={mainColor}
            ref={searchRef}
          />
        </div>
      ) : null}
      <ListWrapper
        onRefresh={onRefresh}
        onLoadMore={onLoadMore}
        isContainer={true}
        scrollerChildrenSelector={'.gallery-home'}
        eventName={'gallery-list'}
      >
        <LiveShow
          {...props}
          onPlayVideo={onPlay}
          inSearch={search}
          currentIndex={currentIndex}
        />
      </ListWrapper>

      {currentIndex >= 0 ? (
        <SimpleBigVideo
          list={!!search ? videoStore.liveshow_search.items : list}
          index={currentIndex}
          setIndex={setCurrentIndex}
          onClose={() => {
            setCurrentIndex(-1);
            // onChangeIndex(-1);

            if (!!search) {
              onSearch('');
              if (
                !!searchRef &&
                !!searchRef.current &&
                typeof searchRef.current.clear == 'function'
              ) {
                searchRef.current.clear();
              }
            }
          }}
          onStatusChange={onStatusChange}
          rootStore={props.rootStore}
          mode={props.mode}
          download={props.download}
          search={search}
        />
      ) : null}
    </div>
  );
};

export default inject('rootStore')(observer(Index));
